export enum TimeFormatErrorEnum {
  InvalidFormat = 'invalidFormat',
}
